export default "__VITE_ASSET__8b6749c4__"